<div class="motif-container">
    <div class="motif-row">
        <div class="motif-col-lg-4 motif-col-lg-offset-4">
            <motif-card >
                <motif-card-body class="text-center">
                    <motif-icon [src]="'/assets/icons/action/ic_schedule_24px.svg'"></motif-icon>
                    <h4 class="text-gray-300 mv-20 text-normal">Your session is expired</h4>
                    <button (click)="renewSession()" class="btn-center mt-3" motifButton color="primary" size="large">
                        Renew Session
                    </button>
                </motif-card-body>
            </motif-card>
        </div>
    </div>
</div>